import { VIEWER_REPORT_ALLOCATION_MODEL_LIST, VIEWER_REPORT_ALLOCATION_SEARCH, VIEWER_REPORT_ALLOCATION_PAGINATION, VIEWER_REPORT_ALLOCATION_DROP_DOWN_SEARCH_TYPE } from './actionType'

export const setModelDeviceListToState = (payload) => ({
    type: VIEWER_REPORT_ALLOCATION_MODEL_LIST,
    payload
})

export const setSearchToState = (payload) => ({
    type: VIEWER_REPORT_ALLOCATION_SEARCH,
    payload
})
export const setPaginationToState = (payload) => ({
    type: VIEWER_REPORT_ALLOCATION_PAGINATION,
    payload
})
export const setDropDownSearchType = (payload) => ({
    type: VIEWER_REPORT_ALLOCATION_DROP_DOWN_SEARCH_TYPE,
    payload
})